import { useMemo } from "react";

import type { RelationLink } from "../types";

export type RelationSection = {
  entity: string;
  links: RelationLink[];
};

export function useRelationSections(links: RelationLink[]): RelationSection[] {
  return useMemo(() => {
    const byEntity = new Map<string, RelationLink[]>();

    for (const link of links) {
      const bucket = byEntity.get(link.entity);

      if (bucket) {
        bucket.push(link);
      } else {
        byEntity.set(link.entity, [link]);
      }
    }

    return [...byEntity.entries()]
      .map(([entity, entityLinks]) => ({
        entity,
        links: [...entityLinks].sort((a, b) =>
          a.displayName.localeCompare(b.displayName),
        ),
      }))
      .sort(
        (a, b) =>
          a.links.length - b.links.length || a.entity.localeCompare(b.entity),
      );
  }, [links]);
}
